export default "__VITE_ASSET__55UGc$nx__"